<div class="tw-flex tw-flex-col tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-lg tw-mx-auto tw-relative">
  <i class="far fa-times tw-cursor-pointer tw-absolute tw-right-4 tw-top-4 tw-text-gray-400 hover:tw-text-gray-600" (click)="close()"></i>
  
  <!-- Título -->
  <div class="tw-text-center tw-mb-6">
    <h3 class="tw-font-['Rubik'] tw-font-bold tw-text-2xl tw-leading-none tw-tracking-normal tw-text-black">
      {{ 'confirmation.title' | translate }}
    </h3>
  </div>

  <!-- Mensaje principal -->
  <div class="tw-text-center tw-mb-8">
    <p class="tw-font-['Rubik'] tw-font-normal tw-text-lg tw-leading-none tw-tracking-normal tw-text-black tw-mb-4">
      {{ 'confirmation.' + modalType + '.main_message' | translate }}
    </p>

    <p class="tw-font-['Rubik'] tw-font-normal tw-text-lg tw-leading-none tw-tracking-normal tw-text-black">
      {{ 'confirmation.demo_message' | translate }}
    </p>
  </div>

  <!-- Botones de acción -->
  <div class="tw-flex tw-gap-4 tw-justify-center">
    <mh-core-lib-button
      customClass="hover:!tw-bg-[#0F93CC]-active active:!tw-bg-[#0F93CC] disabled:!tw-bg-main-disabled disabled:!tw-text-font-disabled"
      [text]="'confirmation.demo_button' | translate"
      width="174"
      [isSecondary]="true"
      [isDisabled]="false"
      (clicked)="handleCancelClick()">
    </mh-core-lib-button>

    <mh-core-lib-button
      customClass="!tw-bg-[#0F93CC] hover:!tw-bg-[#0F93CC]-active active:!tw-bg-[#0F93CC] disabled:!tw-bg-main-disabled disabled:!tw-text-font-disabled"
      [text]="'confirmation.' + modalType + '.confirm_button' | translate"
      width="174"
      [isDefault]="true"
      [isDisabled]="false"
      (clicked)="handleConfirmClick()">
    </mh-core-lib-button>
  </div>
</div>
